<template>
    <div class="container-fluid">
        <Clist :regresar="Regresar"
        :Nombre="Titulo"
        @FiltrarC="Lista"
        :Filtro="Filtro"
        :isModal="EsModal"
        :pShowBtnAdd="false"
        :pConfigLoad="ConfigLoad"
        :isHistorialEquipo="true"
        :ShowPager="ShowPager"
        :ShowFilas="false"
        :ShowBusqueda="false">
            <template slot="DatosEquipo">
                <div class="col-lg-12 mb-3">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="avatar-upload-histequipo">
                                <div class="avatar-edit">
									<input id="ficha" @change="CambiarImagenTrabajador($event)" ref="ficha" type="file" name="ficha" accept=".png, .jpg, .jpeg">
									<label for="ficha"></label>
								</div>
                                <div v-if="BndImagenTrabajador!=0" class="avatar-edit3">
									<button type="button" @click="GuardarImagenTrabajador">
										<i class="fas fa-save"></i>
									</button>
								</div>
                                <div class="avatar-preview">
									<div id="imagePreviewFicha" :style="'background-image: url('+Trabajador.Foto2+');'" :src="Trabajador.Foto2">
									</div>
								</div>
                            </div>
                            <div v-if="BndImagenTrabajador!=0">
								<p class="text-danger text-leyenda">Aún no sube la imagen, presione guardar para subirla</p>
							</div>
                        </div>
                        <div class="col-lg-3">
                            <span class="titulosmonitoreo">Nombre: </span> <span class="text-info titulosmonitoreo">{{ Trabajador.Nombre }}</span>
							<br>
							<span class="titulosmonitoreo">Categoria: </span> <span class="text-info titulosmonitoreo">{{ Trabajador.Categoria }}</span>
							<br>
							<span class="titulosmonitoreo">Perfil: </span> <span class="text-info titulosmonitoreo">{{ Trabajador.Perfil }}</span>
							<br>
							<span class="titulosmonitoreo">Profesion:</span> <span class="text-info titulosmonitoreo">{{ Trabajador.Profesion }}</span>
							<br>
							<span class="titulosmonitoreo">Teléfono: </span> <span class="text-info titulosmonitoreo">{{ Trabajador.Telefono }}</span>
							<br>
							<span class="titulosmonitoreo">Usuario App:</span> <span class="text-info titulosmonitoreo">{{ Trabajador.Usuario }}</span>
							<br>
							<span class="titulosmonitoreo">Contraseña:</span> <span class="text-info titulosmonitoreo">{{ Trabajador.Pass }}</span>
							<br>
                        </div>
                        <div class="col-lg-2">
                            <span class="titulosmonitoreo">Sueldo Anual Integrado: </span> <span class="text-info titulosmonitoreo">${{ Trabajador.SueldoAnualIntegrado }}</span>
							<br>
							<span class="titulosmonitoreo">Mano de Obra / Hora: </span> <span class="text-info titulosmonitoreo">${{ Trabajador.CostoHora }}</span>
							<br>
							<span class="titulosmonitoreo">Horas de Trabajo Semanal: </span> <span class="text-info titulosmonitoreo">{{ Trabajador.HorasTS }}</span>
							<br>
							<span class="titulosmonitoreo">Horario Contractual Ingreso:</span> <span class="text-info titulosmonitoreo">{{ DevolverHora(Trabajador.HoraEntrada,Trabajador.MinutoEntrada) }}</span>
							<br>
							<span class="titulosmonitoreo">Horario Contractual Salida: </span> <span class="text-info titulosmonitoreo">{{ DevolverHora(Trabajador.HoraSalida,Trabajador.MinutoSalida) }}</span>
							<br>
							<span class="titulosmonitoreo">Comida:</span> <span class="text-info titulosmonitoreo">{{ Trabajador.MinutoComida == undefined || Trabajador.MinutoComida == '' ? 'Sin Horario Asignado' : Trabajador.MinutoComida + ' Minutos' }}</span>
							<br>
							<span class="titulosmonitoreo">Supervisor:</span> <span class="text-info titulosmonitoreo">{{ Trabajador.Supervisor}}</span>
							<br>
                        </div>
                        <div class="col-lg-2">
                            <span class="titulosmonitoreo">Fecha de Ingreso: </span> <span class="text-info titulosmonitoreo">{{Trabajador.FechaIngreso==null || Trabajador.FechaIngreso=='0000-00-00' ? 'Sin Fecha' : $getCleanDate(Trabajador.FechaIngreso,false)}}</span>
							<br>
							<span class="titulosmonitoreo">Fecha de Egreso: </span> <span class="text-info titulosmonitoreo">{{ Trabajador.FechaEgreso==null ? 'Activo' : $getCleanDate(Trabajador.FechaEgreso,false) }}</span>
							<br>
                        </div>
                        <div class="col-lg-3">
                            <div class="d-flex justify-content-end">
                                <button class="btn btn-01 mr-2" @click="EditarTrabajador(Trabajador.IdTrabajador)" data-toggle="modal" data-target="#ModalForm">Editar</button>
                                <button class="btn btn-danger" @click="BorrarTrabajador(Trabajador.IdTrabajador)">Eliminar</button>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-inline">
                                <button v-if="Trabajador.AccesoApp=='1'" @click="CambiarPestania('Asistencia')" type="button" :class="Botones.Asistencia ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Asistencia</button>
                                <button v-else class="btn btn-06 text-gray-300 bold m-0 pb-0 pr-2 pt-2" disabled>Asistencia</button>
								<button v-if="Trabajador.AccesoApp=='1'" @click="CambiarPestania('Comida')" type="button" :class="Botones.Comida ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Comida</button>
                                <button v-else class="btn btn-06 text-gray-300 bold m-0 pb-0 pr-2 pt-2" disabled>Comida</button>
								<button v-if="Trabajador.AccesoApp=='1'" @click="CambiarPestania('Eventos')" type="button" :class="Botones.Eventos ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Eventos</button>
                                <button v-else class="btn btn-06 text-gray-300 bold m-0 pb-0 pr-2 pt-2" disabled>Eventos</button>
								<button @click="CambiarPestania('Capacitaciones')" type="button" :class="Botones.Capacitaciones ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Capacitaciones</button>
                                <button @click="CambiarPestania('Material')" type="button" :class="Botones.Material ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Material de Trabajo</button>
                                <button @click="CambiarPestania('Vacaciones')" type="button" :class="Botones.Vacaciones ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Vacaciones y Permisos</button>
                                <button @click="CambiarPestania('Documentos')" type="button" :class="Botones.Documentos ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Docs. Personales</button>
                                <button @click="CambiarPestania('Nomina')" type="button" :class="Botones.Nomina ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Nómina</button>
                                <button @click="CambiarPestania('HistorialPuesto')" type="button" :class="Botones.HistorialPuesto ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Sueldos y Puestos</button>
								<button @click="CambiarPestania('Viaticos')" type="button" :class="Botones.Viaticos ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Viáticos</button>
                                <button v-if="Trabajador.HomeOffice==1" @click="CambiarPestania('HomeOffice')" type="button" :class="Botones.HomeOffice ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Ubicación Home Office</button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="Botones.Asistencia" slot="Filtros">
                <div v-show="ShowFiltroCheckIn" class="form-group mr-2">
                    <select style="width: 150px;" @change="Lista"  v-model="Filtro.Estatus"  class="form-control">
                        <option value="">--Estatus--</option>
                        <option value="Retardo">Retardo</option>
                        <option value="Falta">Falta</option>
                        <option value="HorasExtra">Horas Extra</option>
                    </select>
                </div>
                <div v-show="ShowFiltroCheckIn" class="form-group mr-2">
                    <v-date-picker
                    mode='range'
                    v-model='Filtro.rangeDate'
                    @input="Lista"
                    :input-props='{
                    class: "form-control calendar",
                    placeholder: "Selecciona un rango de fecha para buscar",
                    readonly: true
                    }'/>
                </div>
                <div class="form-group mr-2">
                    <button @click="MostrarFiltro" type="button" class="btn btn-01 mr-2"><i :class="!ShowFiltroCheckIn ? 'fa fa-filter' : 'fa fa-times'"></i> {{ !ShowFiltroCheckIn ? 'Mostrar Filtro' : 'Ocultar Filtro' }}</button>
                    <button @click="ImprimirDetalle" type="button" class="btn btn-pink"><i class="fa fa-print"></i> Imprimir</button>
                </div>
            </template>
            <template v-if="Botones.Asistencia" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Lugar de Trabajo</th>
                    <th>Comentario In</th>
                    <th>Comentario Out</th>
                    <th>Horas Extra</th>
                    <th>Estatus</th>
                    <th>Acciones</th>
                    <th>Observaciones</th>
                    <!-- <th>Cantidad</th> -->
                </tr>
            </template>
            <template v-if="Botones.Asistencia" slot="body">
                <tr v-for="(item,index) in ListaCheck" :key="index">
                    <td>{{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>{{ item.FechaReg != '-' ? FormatearFecha(item.FechaReg) : '-' }}</td>
                    <td>{{ item.FechaCheckOut != '-' ? FormatearFecha(item.FechaCheckOut) : '-' }}</td>
                    <td>{{ item.LugarTrabajo }}</td>
                    <td>{{ $limitCharacters(item.Comentario,30) }}</td>
                    <td>{{ $limitCharacters(item.ComentarioCheckOut,30) }}</td>
                    <td>{{ item.CantidadHoraExtra }}</td>
                    <td>
                        <div class="d-flex justify-content-center">
                            <div v-b-tooltip.hover :title="item.Estatus" :class="DefinirClaseCheck(item.Estatus)"></div>
                        </div>
                    </td>
                    <td>
                        <button v-show="item.FechaReg!='-'" v-b-tooltip.hover.top title="Ver Comentario" @click="VerComentario(item,'In')" class="btn-icon mr-1" data-target="#Comentario" data-toggle="modal">
                            <i class="fa fa-eye"></i>
                        </button>
                        <button v-show="item.FechaReg!='-'" v-b-tooltip.hover.top title="Ver Ubicación Check-In" @click="VerUbicacion(item,'In')" class="btn-icon mr-1" data-target="#Ubicacion" data-toggle="modal">
                            <i class="far fa-map-marked-alt"></i>
                        </button>
                        <button v-show="item.FechaReg!='-'" v-b-tooltip.hover.top title="Ver Comentario" @click="VerComentario(item,'Out')" class="btn-icon mr-1" data-target="#Comentario" data-toggle="modal">
                            <i class="fa fa-eye"></i>
                        </button>
                        <button v-show="item.FechaReg!='-'" v-b-tooltip.hover.top title="Ver Ubicación Check-Out" @click="VerUbicacion(item,'Out')" class="btn-icon mr-1" data-target="#Ubicacion" data-toggle="modal">
                            <i class="far fa-map-marked-alt"></i>
                        </button>
                        <button v-b-tooltip.hover.top title="Cambiar Estatus" @click="AbrirCambioEstatus(item)" class="btn-icon" data-target="#Estatus" data-toggle="modal">
                            <i class="fa fa-pencil"></i>
                        </button>
                    </td>
                    <!-- <td>{{ item.HoraExtra == 1 ? 'Si' : 'No' }}</td> -->
                    <td>{{ $limitCharacters(item.MotivoEstatus,80) }}</td>
                </tr>
            </template>

            <template v-if="Botones.Comida || Botones.Eventos" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>In</th>
                    <th v-show="Botones.Eventos">Site</th>
                    <th>Out</th>
                    <th>Comentario</th>
                    <th>Acciones</th>
                </tr>
            </template>
            <template v-if="Botones.Comida || Botones.Eventos" slot="body">
                <tr v-for="(item,index) in ListaCheck" :key="index">
                    <td>{{ $getCleanDate(item.FechaReg,false) }}</td>
                    <td>{{ FormatearFecha(item.FechaReg) }}</td>
                    <td v-show="Botones.Eventos">{{ FormatearFecha(item.FechaSite) }}</td>
                    <td>{{ FormatearFecha(item.FechaCheckOut) }}</td>
                    <td>{{ $limitCharacters(item.Comentario,50) }}</td>
                    <td>
                        <button @click="VerComentario(item,'In')" class="btn-icon mr-1" data-target="#Comentario" data-toggle="modal">
                            <i class="fa fa-eye"></i>
                        </button>
                        <button v-b-tooltip.hover.top title="Ver Ubicación Check-In" @click="VerUbicacion(item,'In')" class="btn-icon mr-1" data-target="#Ubicacion" data-toggle="modal">
                            <i class="far fa-map-marked-alt"></i>
                        </button>
                        <button v-show="item.FechaSite!=null" v-b-tooltip.hover.top title="Ver Comentario" @click="VerComentario(item,'Site')" class="btn-icon mr-1" data-target="#Comentario" data-toggle="modal">
                            <i class="fa fa-eye"></i>
                        </button>
                        <button v-show="item.FechaSite!=null" v-b-tooltip.hover.top title="Ver Ubicación Site" @click="VerUbicacion(item,'Site')" class="btn-icon mr-1" data-target="#Ubicacion" data-toggle="modal">
                            <i class="far fa-map-marked-alt"></i>
                        </button>
                        <button v-show="item.FechaCheckOut!=null" v-b-tooltip.hover.top title="Ver Comentario" @click="VerComentario(item,'Out')" class="btn-icon mr-1" data-target="#Comentario" data-toggle="modal">
                            <i class="fa fa-eye"></i>
                        </button>
                        <button v-show="item.FechaCheckOut!=null" v-b-tooltip.hover.top title="Ver Ubicación Check-Out" @click="VerUbicacion(item,'Out')" class="btn-icon" data-target="#Ubicacion" data-toggle="modal">
                            <i class="far fa-map-marked-alt"></i>
                        </button>
                    </td>
                </tr>
            </template>

            <template v-if="Botones.Capacitaciones" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>Nombre</th>
                    <th>Comentario</th>
                    <th>Acciones</th>
                    <th>
                        <button @click="NuevaCapacitacion()" type="button" data-toggle="modal" data-target="#Capacitacion" class="btn-obs"><i class="fa fa-plus" title="Agregar Capacitacion"></i></button>
                    </th>
                </tr>
            </template>
            <template v-if="Botones.Capacitaciones" slot="body">
                <tr v-for="(item,index) in ListaCapacitacion" :key="index">
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>{{ item.Nombre }}</td>
                    <td>{{ item.Comentario }}</td>
                    <td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalCapacitacion.EmitSeccion" 
                        :Id="item.IdCapacitacion"
                        :IrA="ConfigModalCapacitacion.Nombre">
                            <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
                </tr>
                <CSinRegistros :pContIF="ListaCapacitacion.length" :pColspan="5"></CSinRegistros>
            </template>

            <template v-if="Botones.Material" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>Nombre</th>
                    <th>Comentario</th>
                    <th>Acciones</th>
                    <th>
                        <button @click="NuevoMaterial()" type="button" data-toggle="modal" data-target="#MaterialTrabajo" class="btn-obs"><i class="fa fa-plus" title="Agregar Material de Trabajo"></i></button>
                    </th>
                </tr>
            </template>
            <template v-if="Botones.Material" slot="body">
                <tr v-for="(item,index) in ListaMaterial" :key="index">
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.FechaReg,false) }}</td>
                    <td>{{ item.Nombre }}</td>
                    <td>{{ item.Comentario }}</td>
                    <td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalMaterialTrabajo.EmitSeccion" 
                        :Id="item.IdMaterialTrabajo"
                        :IrA="ConfigModalMaterialTrabajo.Nombre">
                            <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td></td>
                </tr>
                <CSinRegistros :pContIF="ListaMaterial.length" :pColspan="5"></CSinRegistros>
            </template>

            <template v-if="Botones.Vacaciones" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>Fecha Inicio</th>
                    <th>Fecha Fin</th>
                    <th>Comentario</th>
                    <th>Acciones</th>
                    <th>
                        <button @click="NuevaVacacion()" type="button" data-toggle="modal" data-target="#Vacacion" class="btn-obs"><i class="fa fa-plus" title="Agregar Vacación"></i></button>
                    </th>
                </tr>
            </template>
            <template v-if="Botones.Vacaciones" slot="body">
                <tr v-for="(item,index) in ListaVacaciones" :key="index">
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.FechaReg,false) }}</td>
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.FechaInicio,false) }}</td>
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.FechaFin,false) }}</td>
                    <td>{{ item.Comentario }}</td>
                    <td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalVacacion.EmitSeccion" 
                        :Id="item.IdVacacion"
                        :IrA="ConfigModalVacacion.Nombre">
                            <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
                </tr>
                <CSinRegistros :pContIF="ListaVacaciones.length" :pColspan="6"></CSinRegistros>
            </template>

            <template v-if="Botones.Documentos" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>Nombre</th>
                    <th>Comentario</th>
                    <th>Acciones</th>
                    <th>
                        <button @click="NuevoDocumento()" type="button" data-toggle="modal" data-target="#Documento" class="btn-obs"><i class="fa fa-plus" title="Agregar Documento"></i></button>
                    </th>
                </tr>
            </template>
            <template v-if="Botones.Documentos" slot="body">
                <tr v-for="(item,index) in ListaDocumentos" :key="index">
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.FechaReg,false) }}</td>
                    <td>{{ item.Nombre }}</td>
                    <td>{{ item.Comentario }}</td>
                    <td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalDocumento.EmitSeccion" 
                        :Id="item.IdDocT"
                        :IrA="ConfigModalDocumento.Nombre">
                            <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
                </tr>
                <CSinRegistros :pContIF="ListaDocumentos.length" :pColspan="5"></CSinRegistros>
            </template>

            <template v-if="Botones.Nomina" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>Comentario</th>
                    <th>Acciones</th>
                    <th>
                        <button @click="NuevaNomina()" type="button" data-toggle="modal" data-target="#Nomina" class="btn-obs"><i class="fa fa-plus" title="Agregar Nomina"></i></button>
                    </th>
                </tr>
            </template>
            <template v-if="Botones.Nomina" slot="body">
                <tr v-for="(item,index) in ListaNomina" :key="index">
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>{{ item.Comentario }}</td>
                    <td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalNomina.EmitSeccion" 
                        :Id="item.IdNomina"
                        :IrA="ConfigModalNomina.Nombre">
                            <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td></td>
                </tr>
                <CSinRegistros :pContIF="ListaNomina.length" :pColspan="4"></CSinRegistros>
            </template>

            <template v-if="Botones.HistorialPuesto" slot="header">
                <tr>
                    <th>Fecha</th>
                    <th>Puesto</th>
                    <th>Salario</th>
                    <th>Comentario</th>
                    <th>Acciones</th>
                    <th>
                        <button @click="NuevoHistorialPuesto()" type="button" data-toggle="modal" data-target="#HistorialPuesto" class="btn-obs"><i class="fa fa-plus" title="Agregar Puesto y Salario"></i></button>
                    </th>
                </tr>
            </template>
            <template v-if="Botones.HistorialPuesto" slot="body">
                <tr v-for="(item,index) in ListaHistorial" :key="index">
                    <td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>{{ item.Puesto }}</td>
                    <td>$ {{ item.Salario }}</td>
                    <td>{{  $limitCharacters(item.Comentario,60) }}</td>
                    <td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalHistorialPuesto.EmitSeccion" 
                        :Id="item.IdHistorialPuesto"
                        :IrA="ConfigModalHistorialPuesto.Nombre">
                            <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
                </tr>
                <CSinRegistros :pContIF="ListaHistorial.length" :pColspan="6"></CSinRegistros>
            </template>

			<template v-if="Botones.Viaticos" slot="header">
                <tr>
                    <th>Factura</th>
                    <th>Pago</th>
                    <th>No° de Factura</th>
                    <th>Concepto</th>
					<th>Crédito</th>
					<th>Pagado</th>
					<th>Estatus</th>
					<th>Monto</th>
                    <th>Acciones</th>
                </tr>
            </template>
			<template v-if="Botones.Viaticos" slot="body">
				<tr v-for="(item,index) in ListaViaticos" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaFactura,false)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaPago,false)}}</td>
					<td>{{item.NumFactura}}</td>
					<td>{{item.Concepto}}</td>
					<td class="text-center">{{item.Credito}}</td>
					<td class="text-center">{{item.Estatus}}</td>
					<td>{{item.Vigencia}}</td>
					<td>$ {{formateoMillon(parseFloat(item.Monto))}}</td>
					<td>
						<Cbtnaccion :isModal="true" 
                        :pEmitSeccion="ConfigModalCuenta.EmitSeccion" 
                        :Id="item.IdCtaPagar"
                        :IrA="ConfigModalCuenta.Nombre">
							<template slot="btnaccion" >

								<!-- <button v-if="item.Estatus === 'NO'" v-b-tooltip.hover.leftbottom title="Pagado" @click="Observation(item.IdCtaPagar)" data-toggle="modal" data-target="#Observacion" data-backdrop="static" data-keyboard="false" type="button" class="btn-icon mr-2">
									<i class="fas fa-dollar-sign"></i>
								</button> -->

								<button v-if="item.Estatus==='SI'" v-b-tooltip.hover.leftbottom title="Observación" @click="Observation(item.IdCtaPagar)" data-toggle="modal" data-target="#Observacion" data-backdrop="static" data-keyboard="false" type="button" class="btn-icon mr-2">
									<i class="fas fa-info-circle"></i>
								</button>

								<button v-if="item.Factura !== ''" @click="openInvoice(item)" v-b-tooltip.hover.top title="Factura" type="button" class="btn-icon mr-2">
									<i class="fas fa-file-pdf"></i>
								</button>
								<!-- <button v-if="item.Comprobante !== '' && item.Comprobante != null" @click="AbrirComprobante(item)" v-b-tooltip.hover.top title="Comprobante de Pago" type="button" class="btn-icon mr-2">
									<i class="fas fa-file-pdf"></i>
								</button> -->
							</template>
						</Cbtnaccion>
					</td>
				</tr>
			</template>

            <template v-if="Botones.HomeOffice" slot="mapa">
                <div v-if="BndMostrarMapa" class="position-relative" style="bottom:30px;z-index:1000">
                    <h3>Seleccione la Ubicación Para Home Office</h3>
                    <Search :oLatLng="oLatLngHomeOffice" :Input="true" :pOrigen="'homeoffice'"></Search>
                    <br>
                    <div class="row d-flex justify-content-end">
                        <div class="col-12">
                            <button :disabled="BotonUbicacion.disableBtn" @click="GuardarUbicacion" class="btn btn-01">
                                <i v-show="!BotonUbicacion.disableBtn" class="fa fa-plus-circle"></i>
                                <i v-show="BotonUbicacion.disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> 
                                Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </Clist>
        
        <Modal :size="ConfigModalTrabajador.Size" :Nombre="ConfigModalTrabajador.Nombre" :poBtnSave="oBtnSaveTrabajador">
			<template slot="Form">
				<Trabajador :poBtnSave="oBtnSaveTrabajador"></Trabajador>
			</template>
		</Modal>

        <Modal :pEmitSeccion="ConfigModalComentario.EmitSeccion" :NameModal="ConfigModalComentario.NombreSeccion"  :size="ConfigModalComentario.Size" :Nombre="ConfigModalComentario.Nombre" :poBtnSave="oBtnSaveComentario">
            <template slot="Form">
                <Comentario :NameList="ConfigModalComentario.NameForm" :poBtnSave="oBtnSaveComentario">
                </Comentario>
            </template>
        </Modal>
        
        <Modal :pEmitSeccion="ConfigModalUbicacion.EmitSeccion" :NameModal="ConfigModalUbicacion.NombreSeccion"  :size="ConfigModalUbicacion.Size" :Nombre="ConfigModalUbicacion.Nombre" :poBtnSave="oBtnSaveUbicacion">
            <template slot="Form">
                <Ubicacion :NameList="ConfigModalUbicacion.NameForm" :poBtnSave="oBtnSaveUbicacion">
                </Ubicacion>
            </template>
        </Modal>

        <Modal :pEmitSeccion="ConfigModalCapacitacion.EmitSeccion" :NameModal="ConfigModalCapacitacion.NombreSeccion"  :size="ConfigModalCapacitacion.Size" :Nombre="'Capacitación'" :poBtnSave="oBtnSaveCapacitacion">
            <template slot="Form">
                <Capacitacion :NameList="ConfigModalCapacitacion.NameForm" :poBtnSave="oBtnSaveCapacitacion">
                </Capacitacion>
            </template>
        </Modal>

        <Modal :pEmitSeccion="ConfigModalMaterialTrabajo.EmitSeccion" :NameModal="ConfigModalMaterialTrabajo.NombreSeccion"  :size="ConfigModalMaterialTrabajo.Size" :Nombre="'Material de Trabajo'" :poBtnSave="oBtnSaveMaterialTrabajo">
            <template slot="Form">
                <MaterialTrabajo :NameList="ConfigModalMaterialTrabajo.NameForm" :poBtnSave="oBtnSaveMaterialTrabajo">
                </MaterialTrabajo>
            </template>
        </Modal>

        <Modal :pEmitSeccion="ConfigModalVacacion.EmitSeccion" :NameModal="ConfigModalVacacion.NombreSeccion"  :size="ConfigModalVacacion.Size" :Nombre="'Vacaciones Y Permisos'" :poBtnSave="oBtnSaveVacacion">
            <template slot="Form">
                <Vacacion :NameList="ConfigModalVacacion.NameForm" :poBtnSave="oBtnSaveVacacion">
                </Vacacion>
            </template>
        </Modal>

        <Modal :pEmitSeccion="ConfigModalDocumento.EmitSeccion" :NameModal="ConfigModalDocumento.NombreSeccion"  :size="ConfigModalDocumento.Size" :Nombre="'Documentos Personales'" :poBtnSave="oBtnSaveDocumento">
            <template slot="Form">
                <Documento :NameList="ConfigModalDocumento.NameForm" :poBtnSave="oBtnSaveDocumento">
                </Documento>
            </template>
        </Modal>

        <Modal :pEmitSeccion="ConfigModalEstatus.EmitSeccion" :NameModal="ConfigModalEstatus.NombreSeccion"  :size="ConfigModalEstatus.Size" :Nombre="'Cambio de Estatus'" :poBtnSave="oBtnSaveEstatus">
            <template slot="Form">
                <Estatus :NameList="ConfigModalEstatus.NameForm" :poBtnSave="oBtnSaveEstatus">
                </Estatus>
            </template>
        </Modal>

        <Modal :pEmitSeccion="ConfigModalHistorialPuesto.EmitSeccion" :NameModal="ConfigModalHistorialPuesto.NombreSeccion"  :size="ConfigModalHistorialPuesto.Size" :Nombre="'Historial de Puestos y Salarios'" :poBtnSave="oBtnSaveHistorialPuesto">
            <template slot="Form">
                <HistorialPuesto :NameList="ConfigModalHistorialPuesto.NameForm" :poBtnSave="oBtnSaveHistorialPuesto">
                </HistorialPuesto>
            </template>
        </Modal>

        <Modal :pEmitSeccion="ConfigModalNomina.EmitSeccion" :NameModal="ConfigModalNomina.NombreSeccion"  :size="ConfigModalNomina.Size" :Nombre="'Nomina'" :poBtnSave="oBtnSaveNomina">
            <template slot="Form">
                <Nomina :NameList="ConfigModalNomina.NameForm" :poBtnSave="oBtnSaveNomina">
                </Nomina>
            </template>
        </Modal>

		<Modal :poBtnSave="oBtnSaveCuenta" :size="'modal-lg'" :Nombre="'Operaciones Cuentas Por Pagar'" :pEmitSeccion="ConfigModalCuenta.EmitSeccion" :NameModal="ConfigModalCuenta.NombreSeccion">
			<template slot="Form">
				<Cuenta :poBtnSave="oBtnSaveCuenta"></Cuenta>
			</template>
		</Modal>
		<Modal
			:NameModal="'Observacion'"
			:poBtnSave="oBtnSave2"
			:size="'modal-lg'"
			:Nombre="'Observación'"
		>
			<template slot="Form">
				<Observacion :poBtnSave="oBtnSave2"></Observacion>
			</template>
		</Modal>
    </div>
</template>

<script>
import $$ from "jquery";
import ImagenDefault from "@/images/foto.png";
import Config from "@/helpers/VarConfig.js";
import Modal from '@/components/Cmodal.vue';
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros";
import Trabajador from "@/views/catalogos/personal/Form.vue";
import Comentario from "./forms/Comentario.vue";
import Ubicacion from "./forms/Ubicacion.vue";
import Capacitacion from "./forms/Capacitacion.vue";
import MaterialTrabajo from "./forms/MaterialTrabajo.vue";
import Vacacion from "./forms/Vacacion.vue";
import Documento from "./forms/Documento.vue";
import Estatus from "./forms/CambioEstatus.vue";
import HistorialPuesto from "./forms/HistorialPuesto.vue";
import Nomina from "./forms/Nomina.vue";
import Cuenta from "./forms/Viaticos.vue";
export default {
    components:{
        Modal,
        Clist,
        Cbtnaccion,
        CSinRegistros,
        Comentario,
        Ubicacion,
        Capacitacion,
        MaterialTrabajo,
        Vacacion,
        Trabajador,
        Documento,
        Estatus,
        HistorialPuesto,
        Nomina,
		Cuenta
    },
    props:["Id","pOrigen"],
    data() {
        return {
            Titulo:"Recursos Humanos",
            Regresar:true,
            EsModal:true,
            Filtro:{
                Nombre: "",
				Placeholder: "Nombre..",
				TotalItem: 0,
				Pagina: 1,
				Entrada: 8,
				Show:true,
                rangeDate:{
                    start:null,
                    end:null
                },
                Estatus:''
            },
            ShowFiltroCheckIn:false,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            ShowPager:true,
            ConfigModalTrabajador:{
                NombreSeccion:"Trabajador",
                // EmitSeccion:"Trabajador",
                Size:"modal-size-55-vw",
                Nombre:"Trabajador",
                NameForm:"Trabajador"
            },
            oBtnSaveTrabajador:{
                isModal:true,
                disableBtn:false,
                toast:0,
                // nombreModal:"Trabajador",
                // EmitSeccion:"Trabajador"
            },
            ConfigModalComentario:{
                NombreSeccion:"Comentario",
                EmitSeccion:"Comentario",
                Size:"modal-md",
                Nombre:"Comentario",
                NameForm:"Comentario"
            },
            oBtnSaveComentario:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Comentario",
                EmitSeccion:"Comentario",
                ShowSave:false
            },
            ConfigModalUbicacion:{
                NombreSeccion:"Ubicacion",
                EmitSeccion:"Ubicacion",
                Size:"modal-lg",
                Nombre:"Ubicacion",
                NameForm:"Ubicacion"
            },
            oBtnSaveUbicacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Ubicacion",
                EmitSeccion:"Ubicacion",
                ShowSave:false
            },
            ConfigModalEstatus:{
                NombreSeccion:"Estatus",
                EmitSeccion:"Estatus",
                Size:"modal-md",
                Nombre:"Estatus",
                NameForm:"Estatus"
            },
            oBtnSaveEstatus:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Estatus",
                EmitSeccion:"Estatus"
            },
            ConfigModalCapacitacion:{
                NombreSeccion:"Capacitacion",
                EmitSeccion:"Capacitacion",
                Size:"modal-md",
                Nombre:"Capacitacion",
                NameForm:"Capacitacion"
            },
            oBtnSaveCapacitacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Capacitacion",
                EmitSeccion:"Capacitacion"
            },
            ConfigModalMaterialTrabajo:{
                NombreSeccion:"MaterialTrabajo",
                EmitSeccion:"MaterialTrabajo",
                Size:"modal-md",
                Nombre:"MaterialTrabajo",
                NameForm:"MaterialTrabajo"
            },
            oBtnSaveMaterialTrabajo:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"MaterialTrabajo",
                EmitSeccion:"MaterialTrabajo"
            },
            ConfigModalVacacion:{
                NombreSeccion:"Vacacion",
                EmitSeccion:"Vacacion",
                Size:"modal-md",
                Nombre:"Vacacion",
                NameForm:"Vacacion"
            },
            oBtnSaveVacacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Vacacion",
                EmitSeccion:"Vacacion"
            },
            ConfigModalDocumento:{
                NombreSeccion:"Documento",
                EmitSeccion:"Documento",
                Size:"modal-md",
                Nombre:"Documento",
                NameForm:"Documento"
            },
            oBtnSaveDocumento:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Documento",
                EmitSeccion:"Documento"
            },
            ConfigModalHistorialPuesto:{
                NombreSeccion:"HistorialPuesto",
                EmitSeccion:"HistorialPuesto",
                Size:"modal-md",
                Nombre:"HistorialPuesto",
                NameForm:"HistorialPuesto"
            },
            oBtnSaveHistorialPuesto:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"HistorialPuesto",
                EmitSeccion:"HistorialPuesto"
            },
            ConfigModalNomina:{
                NombreSeccion:"Nomina",
                EmitSeccion:"Nomina",
                Size:"modal-md",
                Nombre:"Nomina",
                NameForm:"Nomina"
            },
            oBtnSaveNomina:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Nomina",
                EmitSeccion:"Nomina"
            },
			oBtnSaveCuenta:{
				isModal: true,
				disableBtn: false,
				toast: 0,
				nombreModal:"Viatico",
                EmitSeccion:"Viatico"
			},
			ConfigModalCuenta:{
                NombreSeccion:"Viatico",
                EmitSeccion:"Viatico",
                Size:"modal-md",
                Nombre:"Viatico",
                NameForm:"Viatico"
            },
			oBtnSave2: {
				isModal: true,
				disableBtn: false,
				toast: 0,
				nombreModal: "Observacion"
			},
            RutaImagen:"",
            ValidElement:Config.validImage2m,
            BndImagenTrabajador:0,
            ContadorImagenTrabajador:0,
            ObjImagenTrabajador:{},
            Trabajador:{
                IdTrabajador:'',
                Nombre:'',
                Teléfono:'',
                Profesión:'',
                Categoria:'',
                CostoHora:0,
                CostoAnual:0,
                IdSucursal:0,
                Usuario:'',
                Pass:'',
                Observaciones:'',
                Perfil:'',
                HorasTS:0,
                HorasPS:0,
                Imagen:'',
                Foto2:'',
                Correo:'',
                Estatus:'',
                AccesoApp:'',
                HoraEntrada:'',
                HoraSalida:'',
                HoraComida:'',
                HoraFinComida:'',
                AutHoraExtra:'',
                FechaReg:'',
                FechaDel:'',
                HomeOffice:0
            },
            Botones:{
                Asistencia:true,
                Comida:false,
                Eventos:false,
                Capacitaciones:false,
                Material:false,
                Vacaciones:false,
                Documentos:false,
                Nomina:false,
                HomeOffice:false,
                HistorialPuesto:false,
				Viaticos:false
            },
            oLatLngHomeOffice:{
                Lat: 19.43120339928868,
				Lng: -99.13450664719238
            },
            BndMostrarMapa:false,
            ListaCheck:[],
			ListaCheckTodos:[],
            ListaCapacitacion:[],
            ListaMaterial:[],
            ListaVacaciones:[],
            ListaDocumentos:[],
            ListaHistorial:[],
            ListaNomina:[],
			ListaViaticos:[],
            Sucursal:{},
            BotonUbicacion:{
                disableBtn:false
            }
        }
    },
    methods: {
        async Lista(){
            this.Filtro.Show=true;
            this.ShowPager=true;
            this.ConfigLoad.ShowLoader=true;
            if (this.Botones.Asistencia) {
                let TipoCheck='';
                TipoCheck='checkin';
                this.$http.get('checkindetalle/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        TipoCheck:TipoCheck,
                        Fecha_I:this.Filtro.rangeDate.start,
                        Fecha_F:this.Filtro.rangeDate.end,
                        Estatus:this.Filtro.Estatus,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaCheck=res.data.data.tabla;
					this.ListaCheckTodos=res.data.data.todos;
                    this.Sucursal=res.data.data.sucursal;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.Comida || this.Botones.Eventos) {
                let TipoCheck='';
                if (this.Botones.Comida) {
                    TipoCheck='comida';
                }
                if (this.Botones.Eventos) {
                    TipoCheck='evento';
                }
                this.$http.get('checkindetalleevento/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        TipoCheck:TipoCheck,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaCheck=res.data.data.tabla;
                    this.Sucursal=res.data.data.sucursal;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.Capacitaciones) {
                this.$http.get('capacitacion/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaCapacitacion=res.data.data.capacitaciones;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.Material) {
                this.$http.get('materialtrabajo/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaMaterial=res.data.data.materialestrabajo;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.Vacaciones) {
                this.$http.get('vacacion/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaVacaciones=res.data.data.vacaciones;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.Documentos) {
                this.$http.get('docstrabajador2/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaDocumentos=res.data.data.docstrabajador;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.HistorialPuesto) {
                this.$http.get('historialpuesto/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaHistorial=res.data.data.historial;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.Nomina) {
                this.$http.get('nomina/get',{
                    params:{
                        IdTrabajador:this.Trabajador.IdTrabajador,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListaNomina=res.data.data.nomina;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
            }
            if (this.Botones.HomeOffice) {
                this.ConfigLoad.ShowLoader=false;
                // this.BndMostrarMapa=false;
                this.Filtro.Show=false;
                this.ShowPager=false;
                // await this.$http.get('clientesucursal/recovery',{
                //     params:{
                //         IdClienteS:this.IdClienteS
                //     }
                // }).then((res)=>{
                //     this.oLatLng.Lat=parseFloat(res.data.data.Clientes.Latitud);
                //     this.oLatLng.Lng=parseFloat(res.data.data.Clientes.Longitud);
                //     this.BndMostrarMapa=true;
                // });
            }
			if (this.Botones.Viaticos) {
				this.$http.get('ctaporpagar/viatico/get',{
					params:{
						IdUsuario:this.Trabajador.IdUsuario
					}
				}).then((res)=>{
					this.ListaViaticos=res.data.data.ctaporpagar;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
        },
        MostrarFiltro(){
            if (this.ShowFiltroCheckIn) {
                this.ShowFiltroCheckIn=false;
            }
            else{
                this.ShowFiltroCheckIn=true;
            }
        },
        GetTrabajador(){
            this.BndMostrarMapa=false;
            this.$http.get("trabajador/recovery",{
                params:{
                    IdTrabajador: this.Trabajador.IdTrabajador
                }
            }).then((res)=>{
                this.Trabajador=res.data.data.trabajador;
                // this.oLatLngHomeOffice={
                //     lat:parseFloat(this.Trabajador.LatHome),
                //     lng:parseFloat(this.Trabajador.LngHome),
                // }
                if ((this.Trabajador.LatHome==null || this.Trabajador.LngHome==null) && this.Trabajador.HomeOffice==1) {
                    // this.bus.$emit("actualCordenadas2");
                    navigator.geolocation.getCurrentPosition(position => {
                        this.oLatLngHomeOffice = {
                            Lat: position.coords.latitude,
                            Lng: position.coords.longitude
                        };
                    });
                }
                else{
                    this.oLatLngHomeOffice={
                        Lat:parseFloat(this.Trabajador.LatHome),
                        Lng:parseFloat(this.Trabajador.LngHome),
                    }
                }
                let imagn = res.data.data.trabajador.Imagen;
				let Fotgn = res.data.data.trabajador.Foto;
				let Fot2gn = res.data.data.trabajador.Foto2;
                if (imagn != "" && imagn != null) {
					this.Trabajador.Foto2 = "data:image/png;base64," + imagn;
				} else if (Fotgn != "" && Fotgn != null) {
					this.Trabajador.Foto2 = res.data.data.UrlFoto + this.Trabajador.Foto2;
				} else if (Fot2gn != "" && Fot2gn != null) {
					this.Trabajador.Foto2 = res.data.data.UrlFoto + this.Trabajador.Foto2;
				} else {
					this.Trabajador.Foto2 = ImagenDefault;
				}
				//this.Img= res.data.data.UrlFoto+ this.trabajador.Foto2;
				this.readURL(this.Trabajador.Foto2);
				if (this.Trabajador.AccesoApp=='0') {
					this.CambiarPestania('Capacitaciones');
				}
            }).finally(()=>{
                this.BndMostrarMapa=true;
            });
        },
        readURL(input) {
			$$("#imagePreviewFicha").css("background-image", "url(" + input + ")");
			$$("#imagePreviewFicha").hide();
			$$("#imagePreviewFicha").fadeIn(650);
		},
        CambiarPestania(index){
            let Botones=this.Botones;
			Object.keys(Botones).forEach(function(key,ind){
				if (key==index) {
					Botones[key]=true;
				}
				else{
					Botones[key]=false;
				}
				// console.log(index)
			});
            this.Filtro.Nombre="";
            this.Filtro.Pagina=1;
            this.Lista();
        },
        CambiarImagenTrabajador(target){
            if (this.ContadorImagenTrabajador==0) {
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreviewFicha'));
				if(this.$refs.ficha.files[0]!=undefined){
					this.BndImagenTrabajador=1;
					this.ContadorImagenTrabajador++;
					this.ObjImagenTrabajador=this.$refs.ficha.files;
				}
				else{
					this.BndImagenTrabajador=0;
				}
			}
			else{
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreviewFicha'));
				if(this.$refs.ficha.files[0]==undefined){
					this.$refs.ficha.files=this.ObjImagenTrabajador;
				}
				else{
					this.ObjImagenTrabajador=this.$refs.ficha.files;
				}
			}
        },
        GuardarImagenTrabajador(){
            // let RutaImagenAnterior=this.Trabajador.Foto2;
            let formData=new FormData();
			let image=this.$refs.ficha.files[0];
			if(image!=undefined){
				if (this.Trabajador.Foto2!=null) {
					let index=this.Trabajador.Foto2.lastIndexOf("/")+1;
					let cadena=this.Trabajador.Foto2.substr(index);	
					formData.set('FotoTrabajadorPrevio','/'+cadena);
				}
                formData.set('IdTrabajador',this.Trabajador.IdTrabajador);
				// formData.set('IdCliente',this.Contacto.IdCliente);
				formData.append('FotoTrabajador',image);
				// this.RutaImagen=image.name;
				// this.$http.post('crmcontactos/imagenexterior/post',formData,{
				// 	'Content-Type':'multipart/form-data'
				// })
                this.$http.post('trabajador/CambiarImagenTrabajador',formData,{
					'Content-Type':'multipart/form-data'
				})
                .then((res)=>{
                    // this.RutaImagen=RutaImagenAnterior;
					this.$toast.success("Imagen guardada");
					// this.bus.$emit('ActualizarImagenExterior',res.data.data.equipos.ImagenExterior);
					this.BndImagenTrabajador=0;
                    this.ContadorImagenTrabajador=0;
                    
				}).finally(() => {
                    this.GetTrabajador();
                });
			}
			else{
				this.$toast.info("Tienes que subir una imagen");
			}
        },
        DevolverHora(Hora,Minuto){
            if (Hora == '' || Minuto == '') {
                return 'Sin Horario Asignado';
            }
            if (parseInt(Minuto)<10) {
                Minuto='0'+Minuto;
            }
            return Hora+':'+Minuto;
        },
        FormatearFecha(Fecha){
            if (Fecha!=null) {
                let FechaObj=new Date(Fecha);
                let Hora=FechaObj.getHours();
                let Minuto=FechaObj.getMinutes() < 10 ? '0'+FechaObj.getMinutes() : FechaObj.getMinutes();
                return Hora+':'+Minuto;
            }
            else{
                return '-';
            }
        },
        DefinirClaseCheck(Status){
            let Clase="";
            switch (Status) {
                case "Puntual":
                    Clase="circuloStatusOperando";
                    break;
                case "Tolerancia":
                    Clase="circuloStatusObservacion";
                    break;
                case "Atraso":
                    Clase="circuloStatusFueraServicio";
                    break;
				case "Falta":
                    Clase="circuloStatusNegro";
                    break;
                case "Hora Extra":
                    Clase="circuloStatusAzul";
                    break;
                case "Horas Extra":
                    Clase="circuloStatusAzul";
                    break;
                default:
                    Clase="circuloStatusDefault";
                    break;
            }
            return Clase;
        },
        EditarTrabajador(Index){
            this.bus.$emit("Nuevo",null,Index);
        },
        BorrarTrabajador(Id){
            this.$swal({
                    title: 'Esta seguro que desea eliminar este dato?',
                    text: 'No se podra revertir esta acción',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No, mantener',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                    }).then((result) => {
                    if(result.value) {
                         this.$http.delete(
                            'trabajador/' + Id
                        ).then( (res) => {
                            this.$toast.success('Información eliminada');
							this.bus.$emit("Regresar");
                            // this.Lista();
                        });
                    }
                });
        },
        EliminarCapacitacion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'capacitacion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
        EliminarMaterial(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'materialtrabajo/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
        EliminarVacacion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vacacion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
        EliminarHistorialPuesto(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'historialpuesto/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
        EliminarNomina(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'nomina/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
        EliminarDocumento(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'docstrabajador2/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
        VerComentario(Item,Tipo){
            if (Item.TipoCheck=='checkin') {
                if (Tipo=='In') {
                    this.ConfigModalComentario.Nombre='Check In';
                }
                else{
                    this.ConfigModalComentario.Nombre='Check Out';
                }
            }
            if (Item.TipoCheck=='comida') {
                this.ConfigModalComentario.Nombre='Comida';
            }
            if (Item.TipoCheck=='evento1' || Item.TipoCheck=='evento2' || Item.TipoCheck=='evento3') {
                this.ConfigModalComentario.Nombre='Eventos';
            }
            this.bus.$emit('NewModal_'+this.ConfigModalComentario.EmitSeccion,Item,Tipo);
        },
        VerUbicacion(Item,Tipo){
            this.bus.$emit('NewModal_'+this.ConfigModalUbicacion.EmitSeccion,Item,Tipo,this.Sucursal);
        },
        AbrirDocumento(Nombre){
            let archivo = Nombre;
			window.open(
				archivo,
				"_blank",
				"toolbar=1, scrollbars=1, resizable=1, width=" +
					1015 +
					", height=" +
					800
			);
        },
        NuevaCapacitacion(){
            this.bus.$emit('NewModal_'+this.ConfigModalCapacitacion.EmitSeccion,true,0,this.Trabajador.IdTrabajador);
        },
        NuevoMaterial(){
            this.bus.$emit('NewModal_'+this.ConfigModalMaterialTrabajo.EmitSeccion,true,0,this.Trabajador.IdTrabajador);
        },
        NuevaVacacion(){
            this.bus.$emit('NewModal_'+this.ConfigModalVacacion.EmitSeccion,true,0,this.Trabajador.IdTrabajador);
        },
        NuevoDocumento(){
            this.bus.$emit('NewModal_'+this.ConfigModalDocumento.EmitSeccion,true,0,this.Trabajador.IdTrabajador);
        },
        NuevoHistorialPuesto(){
            this.bus.$emit('NewModal_'+this.ConfigModalHistorialPuesto.EmitSeccion,true,0,this.Trabajador.IdTrabajador);
        },
        NuevaNomina(){
            this.bus.$emit('NewModal_'+this.ConfigModalNomina.EmitSeccion,true,0,this.Trabajador.IdTrabajador);
        },
        AbrirCambioEstatus(Item){
            this.bus.$emit('NewModal_'+this.ConfigModalEstatus.EmitSeccion,true,Item.IdCheck,Item.IdTrabajador,Item.Fecha);
        },
        async ImprimirDetalle(){
			let FechaInicio='';
			let FechaFin='';
			if (this.Filtro.rangeDate.start !='' && this.Filtro.rangeDate.start!=undefined) {
				let day=this.Filtro.rangeDate.start.getDate();
                let month=this.Filtro.rangeDate.start.getMonth()+1;
                let year=this.Filtro.rangeDate.start.getFullYear();
                FechaInicio=year+'-'+month+'-'+day;
			}
			if (this.Filtro.rangeDate.end !='' && this.Filtro.rangeDate.end!=undefined) {
				let day=this.Filtro.rangeDate.end.getDate();
                let month=this.Filtro.rangeDate.end.getMonth()+1;
                let year=this.Filtro.rangeDate.end.getFullYear();
                FechaFin=year+'-'+month+'-'+day;
			}
            let formData=new FormData();
            formData.set('Trabajador',JSON.stringify(this.Trabajador));
            formData.set('Tabla',JSON.stringify(this.ListaCheckTodos));
            formData.set('FechaInicio',FechaInicio);
            formData.set('FechaFin',FechaFin);
            await this.$http.post('checkinpdfdetalle',formData,{responseType: 'blob'}).then((res)=>{
                let pdfContent = res.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
            });
        },
        GuardarUbicacion(){
            this.BotonUbicacion.disableBtn=true;
            let formData=new FormData();
            formData.set('IdTrabajador',this.Trabajador.IdTrabajador);
            formData.set('LatHome',this.oLatLngHomeOffice.Lat);
            formData.set('LngHome',this.oLatLngHomeOffice.Lng);
            this.$http.post('trabajador/CambiarUbicacionHome',formData).then((res)=>{
                this.bus.$emit('List');
                this.BotonUbicacion.disableBtn=false;
                this.$toast.success('Ubicación Actualizada');
            }).catch((err)=>{
                this.BotonUbicacion.disableBtn=false;
                this.$toast.warning(err.res.data.message);
            });
        },
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
    },
    created() {
        var date = new Date(),
			y = date.getFullYear(),
			m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		this.Filtro.rangeDate = {
			start: firstDay,
			end: lastDay
		};
        this.Trabajador.IdTrabajador=this.Id;
        this.GetTrabajador();
        this.Lista();
        this.bus.$off('List');
        this.bus.$on('List',()=>{
            this.GetTrabajador();
        });
        this.bus.$off('ListaPrincipal');
        this.bus.$on('ListaPrincipal',()=>{
            this.Lista();
        });
        this.bus.$off('Delete_'+this.ConfigModalCapacitacion.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalCapacitacion.EmitSeccion,(Id)=>{
            this.EliminarCapacitacion(Id);
        });
        this.bus.$off('Delete_'+this.ConfigModalMaterialTrabajo.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalMaterialTrabajo.EmitSeccion,(Id)=>{
            this.EliminarMaterial(Id);
        });
        this.bus.$off('Delete_'+this.ConfigModalVacacion.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalVacacion.EmitSeccion,(Id)=>{
            this.EliminarVacacion(Id);
        });
        this.bus.$off('Delete_'+this.ConfigModalDocumento.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalDocumento.EmitSeccion,(Id)=>{
            this.EliminarDocumento(Id);
        });
        this.bus.$off('Delete_'+this.ConfigModalHistorialPuesto.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalHistorialPuesto.EmitSeccion,(Id)=>{
            this.EliminarHistorialPuesto(Id);
        });
        this.bus.$off('Delete_'+this.ConfigModalNomina.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalNomina.EmitSeccion,(Id)=>{
            this.EliminarNomina(Id);
        });
        this.bus.$off('Regresar');
        this.bus.$on('Regresar',()=> 
        {
			if (this.pOrigen=='Lista') {
				this.$router.push({name:'checkin'});	
			}
			else{
				this.$router.push({name:'personalrh'});
			}
        });
    },
}
</script>

<style>

</style>
